<template>
    <div class="d-f" :class="{'isScroll': isScroll=='1'}">
        <div class="logo">
            <img src="../assets/logo.png" style="cursor: pointer;" @click="toIndex()"/>
        </div>
        <div class="f-1"></div>
        <div class="d-f">
            <div class="f-1 headMain" @click="copyMail">
                <div class="d-f">
                    <img v-if="isScroll == '0'" src="../assets/mail_1.png"/>
                    <img v-if="isScroll == '1'" src="../assets/mail_2.png"/>
                    <div class="mailText">support@together-tech.jp</div>
                </div>
                <div class="timeText">Service Hours: Open All Year Round</div>
            </div>
            <el-popover
                :width="150"
                popper-style="padding: 0.5vw;"
            >
                <template #reference>
                    <div class="kefu">Contact Support</div>
                </template>
                <div>
                    <img class="kefuQr" src="../assets/kefu_qr.png"/>
                    <div class="kefuText">Contact Support</div>
                </div>
            </el-popover>
            <div class="fanwei" @click="changeShowAddr">Service Area</div>

            <div class="fanwei111">
                <el-select class="lang-select" @change="handleLangChange"  v-model="lang" style="" placeholder="Language">
                    <el-option label="English" value="en"/>
                    <el-option label="日本語" value="ja"/>
                    <el-option label="中文" value="zh"/>
                </el-select>
            </div>
            

        </div>

        <el-popover
            :width="menuWidth"
            popper-style="padding: 0.5vw;"
        >
            <template #reference>
                <img class="menu" v-if="isScroll == '0'" src="../assets/menu_1.png"/>
                <img class="menu" v-if="isScroll == '1'" src="../assets/menu_2.png"/>
            </template>
            <div>
                <div class="d-f introMenu" @click="toIntro">
                    <div class="introIcon"></div>
                    <div class="menuText f-1">Company Profile</div>
                    <img class="rightIcon" src="../assets/right_icon.png"/>
                </div>
            </div>
        </el-popover>
    </div>
</template>

 
<script>
import {ElMessage} from "element-plus";

export default {
    name: "ollaHead",
    data() {
        return {
            lang:'en',
            menuWidth: "270"
        };
    },
    props:{
        isScroll:String
    },
    created() {
        this.setMenuWidth()
    },
    mounted() {
        window.onresize = () => {
            return (() => {
                this.setMenuWidth()
            })()
        }
    },
    methods: {
        handleLangChange(v){
            // console.log( v , 'lang ')
            if( v == 'ja'){
                this.$router.push({path:'/jp'});
            }else if( v == 'zh'){
                this.$router.push({path:'/zh'});
            }
        },
        setMenuWidth() {
            var val = document.body.clientWidth
            const def = 768 // 默认宽度
            if (val < def) {
                this.menuWidth = '100vw';
            } else {
                this.menuWidth = '270';
            }
        },
        toIndex(){
            this.$router.push({path:'/'});
        },
        changeShowAddr(){
            this.$emit('changeShowAddr');
        },
        toIntro(){
            this.$router.push({path:'/ollaIntro'});
        },
        async copyMail(){
            await this.$copyText('support@together-tech.jp');

            ElMessage({message:'copy success',type:"success"});
        }
    }
}
</script>

<style scoped>
    .lang-select {
    width: 90px;
    /* height: 36px; */
    border-radius: 18px; /* 圆角 */
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    }

    .lang-select:hover {
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    }

    .lang-select .el-input__wrapper {
    border-radius: 18px;
    border: 1px solid #ddd;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 500;
    }

    .lang-select .el-input__wrapper:hover {
    border-color: #409EFF; /* Element Plus 主题蓝 */
    }

    .lang-select .el-input__inner {
    text-align: center; /* 文字居中 */
    color: #333;
    }

    .el-select-dropdown__item {
    font-size: 14px;
    padding: 8px 12px;
    transition: background 0.2s ease;
    }

    .el-select-dropdown__item:hover {
    background: #f5f7fa;
    color: #409EFF;
    }

    .d-f{
        display: flex;
    }
    .f-1{
        flex: 1;
    }
    .isScroll{
        background-color: white;
        box-shadow: 0px 0.6vw 1.1vw 0px rgba(0,0,0,0.06);
    }
    .logo{
        width: 9.4vw;
        height: 3.75vw;
        margin: 1.13vw 0 1.13vw 8vw;
    }
    .logo img{
        width: 100%;
        height: 100%;
    }

    .headMain{
        height: 3.5vw;
        margin: 1.25vw 2.5vw 1.25vw 0;
    }
    .headMain img{
        height: 1.7vw;
        width: 1.7vw;
        margin: 0.15vw 0.8vw 0 0;
    }
    .headMain .mailText{
        color: white;
        line-height: 2vw;
        font-size: 1.4vw;
        font-weight: bold;
    }
    .headMain .timeText{
        color: rgba(255,255,255,0.8);
        line-height: 1.8vw;
        font-size: 1vw;
    }

    .kefu{
        background: #FFFFFF;
        border-radius: 8px;
        color: black;
        margin: 1.52vw 1.7vw 1.52vw 0;
        height: 2.96vw;
        line-height: 2.96vw;
        padding: 0 1.1vw;
        font-size: 1.1vw;
    }

    .isScroll .kefu{
        background: rgba(255,78,82,0.12)!important;
        color: #FF4E52!important;
    }

    .isScroll .headMain .mailText{
        color: #303030!important;
    }
    .isScroll .headMain .timeText{
        color: rgba(48,48,48,0.8);
    }

    .fanwei{
        cursor: pointer;
        background: #FF4E52;
        border-radius: 8px;
        color: white;
        margin: 1.52vw 3.4vw 1.52vw 0;
        height: 2.96vw;
        line-height: 2.96vw;
        padding: 0 1.1vw;
        font-size: 1.1vw;
    }
    .fanwei111{
        cursor: pointer;
        /* background: #FF4E52; */
        /* border-radius: 8px; */
        /* color: white; */
        margin: 1.52vw 0.8vw 1.52vw 0;
        height: 2.96vw;
        line-height: 2.96vw;
        /* padding: 0 1.1vw; */
        font-size: 1.1vw;
    }

    .menu{
        cursor: pointer;
        width: 2vw;
        height: 2vw;
        margin: 2vw 8vw 2vw 0;
    }

    .kefuQr{
        width: 100%;
        height: 100%;
    }
    .kefuText{
        text-align: center;
        font-size: 12px;
        color: #585E65;
    }

    .introMenu{
        cursor: pointer;
        height: 44px;
    }

    .introIcon{
        width: 24px;
        height: 24px;
        margin: 10px 0 0 24px;
        background-image: url("../assets/intro_icon.png");
        background-repeat: no-repeat;
        background-size: 100%;
    }
    .menuText{
        line-height: 44px;
        text-align: center;
        font-size: 14px;
    }
    .introMenu:hover{
        .introIcon{
            background-image: url("../assets/intro_icon_hover.png");
        }
        .menuText{
            color: #FF4E52;;
        }
    }

    .rightIcon{
        width: 20px;
        height: 20px;
        margin: 12px 24px 0 0;
    }

    @media (max-width: 768px) {
        .logo{
            width: 75px;
            height: 30px;
            margin: 9px 0 0 16px;
        }

        .kefu{
            display: none;
        }
        .fanwei{
            display: none;
        }

        .headMain{
            height: 22px;
            margin: 13px 16px 0 0;
        }
        .headMain img{
            height: 16px;
            width: 16px;
            margin: 4px 4px 0 0;
        }
        .headMain .mailText{
            line-height: 22px;
            font-size: 16px;
        }
        .headMain .timeText{
            display: none;
        }
        .menu{
            width: 24px;
            height: 24px;
            margin: 12px 16px 0 0;
        }
    }
</style>